module.exports = __webpack_public_path__ + "img/洱海1_1.3f9fdc56.jpg";